import {color} from '@sanity/color'

import {ThemeColorPalette} from '../config'

export const defaultColorPalette: ThemeColorPalette = color
